export class LuggageAmountValues {
    luggageTypeId: number;
    value: number;
}
